<!-- Overlay pour fermer en cliquant à côté -->
@if (isOpen) {
  <div class="sidenav-overlay" (click)="toggle()"></div>
}

<!-- Sidenav -->
<div class="sidenav-filters" [@slideInOut]="isOpen ? 'in' : 'out'">
  <!-- Main view header -->
  @if (!currentDetailView) {
    <div class="sidenav-header">
      <p class="filter-title">{{ "sidenavFilters.title" | translate }}</p>
      <button class="sidenav-close-btn" (click)="toggle()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <!--
    Detail view header: back to the filter list, and which filter this is. Icon
    and title come from the same table the row does, so a row and the view it
    opens cannot drift apart.
  -->
  @if (currentDetailView) {
    <div class="sidenav-header detail-header">
      <button class="back-btn" (click)="closeDetailView()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="detail-title-container">
        <svg-icon
          class="detail-icon"
          [name]="detailIcon(currentDetailView)"
        ></svg-icon>
        <p class="filter-title">
          {{ "element.title." + currentDetailView | translate }}
        </p>
        @if (detailCount(currentDetailView) > 0) {
          <span class="selected-count">{{
            detailCount(currentDetailView)
          }}</span>
        }
      </div>
      <button class="sidenav-close-btn" (click)="toggle()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <div class="information-divider"></div>

  <!-- Main view content -->
  @if (!currentDetailView) {
    <div class="main-view">
      <!--
        Two kinds of row, one control behind both. The four server-paged lists
        are rows that drill into a view of their own, because searching and
        scrolling a long list wants the whole sidebar height. The short static
        option sets beside them are the same control in panel chrome, expanded in
        place because there is nothing to wait for.
      -->
      <mat-accordion class="sidenav-sections" multi>
        <!-- Emballage -->
        <div
          class="filter-item-clickable"
          (click)="openDetailView('containerType')"
        >
          <div class="filter-item-header">
            <svg-icon
              class="filter-icon"
              [name]="detailIcon('containerType')"
            ></svg-icon>
            <span class="filter-label">{{
              "element.title.containerType" | translate
            }}</span>
            @if (filterContainers.length > 0) {
              <span class="filter-count">{{ filterContainers.length }}</span>
            }
            <mat-icon class="chevron-icon">chevron_right</mat-icon>
          </div>
          @if (filterContainers.length > 0) {
            <div class="filter-preview">{{ filterContainers.join(", ") }}</div>
          }
        </div>
        <!-- Catégorie d'emballage -->
        <app-filter-panel
          chrome="panel"
          [type]="'checkbox'"
          [label]="'containerCategory'"
          [searchable]="false"
          [icon]="'pallet'"
          [checkedData]="filterContainerCategory"
          (manageList)="manageContainerCategory($event)"
          [expanded]="true"
        ></app-filter-panel>
        <!-- Incident -->
        <div class="filter-item-clickable" (click)="openDetailView('incident')">
          <div class="filter-item-header">
            <svg-icon
              class="filter-icon"
              [name]="detailIcon('incident')"
            ></svg-icon>
            <span class="filter-label">{{
              "element.title.incident" | translate
            }}</span>
            @if (filterIncidents.length > 0) {
              <span class="filter-count">{{ filterIncidents.length }}</span>
            }
            <mat-icon class="chevron-icon">chevron_right</mat-icon>
          </div>
          @if (filterIncidents.length > 0) {
            <div class="filter-preview">{{ filterIncidents.join(", ") }}</div>
          }
        </div>
        <!-- Site de départ -->
        <div
          class="filter-item-clickable"
          (click)="openDetailView('lastAuthorizedSite')"
        >
          <div class="filter-item-header">
            <svg-icon
              class="filter-icon"
              [name]="detailIcon('lastAuthorizedSite')"
            ></svg-icon>
            <span class="filter-label">{{
              "element.title.lastAuthorizedSite" | translate
            }}</span>
            @if (filterLastSites.length > 0) {
              <span class="filter-count">{{ filterLastSites.length }}</span>
            }
            <mat-icon class="chevron-icon">chevron_right</mat-icon>
          </div>
          @if (filterLastSites.length > 0) {
            <div class="filter-preview">{{ filterLastSites[0] }}</div>
          }
        </div>
        <!-- Couleur du status -->
        <app-filter-panel
          chrome="panel"
          [type]="'colorStatus'"
          [label]="'colorStatus'"
          [icon]="'color-status'"
          [colorStatusData]="filterStatus"
          (manageList)="managecolorStatus($event)"
          [expanded]="true"
        ></app-filter-panel>
        <!-- Précision de la localisation -->
        <app-filter-panel
          chrome="panel"
          [type]="'checkbox'"
          [label]="'radius'"
          [searchable]="false"
          [icon]="'radius'"
          [checkedData]="filterConfidenceRadius"
          (manageList)="manageConfidenceRadius($event)"
          [expanded]="true"
        ></app-filter-panel>
        <!-- Type de capteur -->
        <app-filter-panel
          chrome="panel"
          [type]="'checkbox'"
          [label]="'devicesTypes'"
          [searchable]="false"
          [icon]="'devices-types'"
          [checkedData]="filterDevicesTypes"
          (manageList)="manageDevicesTypes($event)"
          [expanded]="true"
        ></app-filter-panel>
        <!-- Fenêtre d'historique -->
        <app-filter-panel
          chrome="panel"
          [type]="'range'"
          [label]="'days'"
          [icon]="'calendar'"
          [rangeData]="filterStatusDays"
          (manageList)="manageStatusDays($event)"
          [expanded]="true"
        ></app-filter-panel>
        <!-- Tracker -->
        <div class="filter-item-clickable" (click)="openDetailView('device')">
          <div class="filter-item-header">
            <svg-icon
              class="filter-icon"
              [name]="detailIcon('device')"
            ></svg-icon>
            <span class="filter-label">{{
              "element.title.device" | translate
            }}</span>
            @if (filterDevices.length > 0) {
              <span class="filter-count">{{ filterDevices.length }}</span>
            }
            <mat-icon class="chevron-icon">chevron_right</mat-icon>
          </div>
          @if (filterDevices.length > 0) {
            <div class="filter-preview">
              {{ filterDevices.slice(0, 3).join(", ") }}
              @if (filterDevices.length > 3) {
                <span>...</span>
              }
            </div>
          }
        </div>
        <!-- Torn -->
        <app-filter-panel
          chrome="panel"
          [type]="'radio'"
          [label]="'torn'"
          [icon]="'torn'"
          [radioData]="tornFilterOptions"
          [defaultRadioValue]="filterTorn"
          (manageList)="manageTorn($event)"
          [isEmpty]="!tornFilterOptions.length"
          [pathTranslate]="'filter.torn.label.{{item}}'"
          [expanded]="true"
        ></app-filter-panel>
        <!-- Unknown -->
        <app-filter-panel
          chrome="panel"
          [type]="'radio'"
          [label]="'unknown'"
          [icon]="'unknown'"
          [radioData]="unknownFilterOptions"
          [defaultRadioValue]="filterUnknown"
          (manageList)="manageUnknown($event)"
          [isEmpty]="!unknownFilterOptions.length"
          [pathTranslate]="'filter.unknown.label.{{item}}'"
          [expanded]="true"
        ></app-filter-panel>
      </mat-accordion>
      <!-- Action buttons -->
      <div class="action-buttons main-view-buttons">
        <button class="btn-secondary" (click)="clearAllFilters()">
          {{ "sidenavFilters.actions.clearAll" | translate }}
        </button>
        <button class="btn-primary" (click)="applyAllFilters()">
          {{ "sidenavFilters.actions.apply" | translate }}
        </button>
      </div>
    </div>
  }

  <!--
    Detail view content: one filter, the same control the list uses, in the
    chrome that fills the sidebar body — so its search, paging and live emit are
    the ones every other filter already has. Clear all here clears this filter
    only; Apply just walks back, the tick having already been emitted.
  -->
  @if (currentDetailView) {
    <div class="detail-view">
      @switch (currentDetailView) {
        @case ("containerType") {
          <app-filter-panel
            chrome="detail"
            [type]="'checkbox'"
            [label]="'containerType'"
            [icon]="'container'"
            [checkedData]="filterContainers"
            (manageList)="manageContainers($event)"
          ></app-filter-panel>
        }
        @case ("incident") {
          <app-filter-panel
            chrome="detail"
            [type]="'checkbox'"
            [label]="'incident'"
            [icon]="'incident'"
            [checkedData]="filterIncidents"
            (manageList)="manageIncidents($event)"
          ></app-filter-panel>
        }
        @case ("lastAuthorizedSite") {
          <app-filter-panel
            chrome="detail"
            [type]="'checkbox'"
            [label]="'lastAuthorizedSite'"
            [icon]="'last-site'"
            [checkedData]="filterLastSites"
            (manageList)="manageLastSites($event)"
          ></app-filter-panel>
        }
        @case ("device") {
          <app-filter-panel
            chrome="detail"
            [type]="'checkbox'"
            [label]="'device'"
            [icon]="'device'"
            [checkedData]="filterDevices"
            (manageList)="manageDevices($event)"
          ></app-filter-panel>
        }
      }
      <!-- Action buttons -->
      <div class="action-buttons">
        <button class="btn-secondary" (click)="clearDetailFilter()">
          {{ "sidenavFilters.actions.clearAll" | translate }}
        </button>
        <button class="btn-primary" (click)="closeDetailView()">
          {{ "sidenavFilters.actions.apply" | translate }}
        </button>
      </div>
    </div>
  }
</div>
